import { Radio } from "lucide-react";

const StreamTileDesign = {
  id: "church-stream",
  icon: Radio,
  label: "Oikos Live Stream Studio",
  background: "#1D4ED8",
  color: "#ffffff",
};

export default StreamTileDesign;
